/** @jsxImportSource @emotion/react */

import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import PageTemplate from '@page/iyagigo/page-template';
import CharacterStudy from '@component/iyagigo/classroom/character-study';
import HeaderProgress from '@component/iyagigo/common/header-progress';
import { useTypedDispatch } from '@hook/common/useStore';
import { actions as modalActions } from '@store/slice/modal-slice';
import { actions as classroomActions } from '@store/slice/classroom-slice';

const CharacterPage: React.FC<any> = () => {
  const dispatch = useTypedDispatch();
  // ############### route ###############
  const [searchParams] = useSearchParams();
  const characterStudyKey = `${searchParams.get('characterType')}:${searchParams.get('group')}`;

  // ############### state ###############
  // 학습 진행(카드+퀴즈) — CharacterStudy가 onProgress로 올려줌. total>0일 때만 프로그레스바 노출
  const [progress, setProgress] = useState<{ current: number; total: number }>({ current: 0, total: 0 });

  useEffect(() => {
    dispatch(classroomActions.storeIsStudying(true));
    return () => {
      dispatch(classroomActions.storeIsStudying(false));
    };
  }, [dispatch]);

  // ############### handler ###############
  const handleBackClick = () => {
    dispatch(
      modalActions.showDialogModal({
        type: 'workbook-quit',
        data: { mainMenu: 'classroom', subMenu: 'character' },
      }),
    );
  };

  return (
    <PageTemplate
      title='글자 학습'
      mode={'close'}
      handleNavigationClick={handleBackClick}
      customHeader={
        progress.total > 0 ? (
          <HeaderProgress currentProgress={progress.current} totalProgress={progress.total} />
        ) : undefined
      }>
      <CharacterStudy key={characterStudyKey} onProgress={setProgress} />
    </PageTemplate>
  );
};

export default CharacterPage;
